
import { Component, Vue } from 'vue-property-decorator'
import { postFetch } from '@/service/common'
import { isNull } from '@/utils/fun'
import { captchaUrl } from '@/service/url'
@Component({})
export default class PhoneLogin extends Vue {
  form: any = {}
  url = ''
  codeId = 0
  timeNumber = 0
  showTimer = false
  timer: any = null
  loginLoading = false
  sendLoading = false
  rules: object = {
    mobile: [
      {
        required: true,
        message: '请输入用户名或手机号',
        trigger: 'change',
      },
    ],
    vcode: [
      {
        required: true,
        message: '请输入验证码',
        trigger: 'change',
      },
    ],
  }
  created() {
    this.getCodeImage()
  }
  beforeDestroy() {
    clearInterval(this.timer)
  }

  handleSubmit() {
    const vm: any = this.$refs.ruleForm
    vm.validate((valid: any) => {
      if (valid) {
        this.loginLoading = true
        this.$emit('submit', 'phoneLogin', this.form, () => {
          this.loginLoading = false
          this.getCodeImage()
        })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  async getCodeImage() {
    const codeId = new Date().getTime() + Math.floor(Math.random() * 1000)
    this.codeId = codeId
    this.url = `${captchaUrl}?code_id=${codeId}`
  }

  async sendMessage() {
    if (isNull(this.form.mobile)) {
      this.$message.error('请先输入手机号')
      return false
    }
    if (isNull(this.form.img_code)) {
      this.$message.error('请先输入图片验证码')
      return false
    }
    const { vcode, ...rest } = this.form
    const params = {
      ...rest,
      code_id: this.codeId,
      oper: 'mobilecodelogin', //手机号登录
    }
    this.sendLoading = true
    try {
      const { code, msg }: any = await postFetch('sendSmsCode', params)
      if (code === 0) {
        this.$message.success('短信已发送，请注意查收')
        this.timeNumber = 60
        this.showTimer = true
        this.timer = setInterval(() => {
          if (this.timeNumber > 0) {
            this.timeNumber--
          } else {
            clearInterval(this.timer)
            this.showTimer = false
            this.getCodeImage()
          }
        }, 1000)
      } else {
        this.$message.error(msg)
      }
    } catch (error) {
      console.log(
        '🚀 ~ file: LoginContent.vue ~ line 115 ~ LoginContent ~ doLogin ~ error',
        error
      )
    }
    this.sendLoading = false
  }
}
